import { pluralize } from '@gonfalon/format/pluralize';
import type { Team } from '@gonfalon/members/types';
import { useTeam } from '@gonfalon/rest-api/hooks/useTeam';
import { Icon } from '@launchpad-ui/icons';
import cx from 'clsx';

import styles from './SelectMembersAndTeams.module.css';

export function TeamOption(props: { teamKey: string; team?: Team }) {
  const teamQuery = useTeam({ teamKey: props.teamKey }, { enabled: !props.team });
  const team = props.team ?? teamQuery.data;

  if (team) {
    const memberCount = team.members?.totalCount ?? 0;

    return (
      <span className="u-flex u-flex-row u-flex-middle u-fs-sm">
        <Icon name="group" className={styles.teamAvatar} size="medium" />
        <div className="u-o-hidden u-to-ellipsis">
          <div className={cx({ [styles.teamOption]: memberCount > 0 })}>
            {team.name} ({memberCount} {pluralize(memberCount, 'person', 'people')})
          </div>
        </div>
      </span>
    );
  }

  return null;
}
